import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // NOTA: Colori hardcoded intenzionali - componente fallback di emergenza
      // deve funzionare anche se CSS variables crashano. Non sostituire.
      return (
        <div style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#F0F1F6',
          fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        }}>
          <div style={{ textAlign: 'center', maxWidth: 420, padding: 24 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12,
              background: '#4FAF8A', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px',
            }}>
              <span style={{ color: '#fff', fontWeight: 500, fontSize: 22, fontStyle: 'italic' }}>m</span>
            </div>
            <h1 style={{ fontSize: 20, fontWeight: 500, color: '#1E212C', marginBottom: 8 }}>
              Qualcosa è andato storto
            </h1>
            <p style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginBottom: 24 }}>
              Si è verificato un errore imprevisto. Ricarica la pagina o contatta il supporto.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#4FAF8A', color: '#fff', border: 'none',
                padding: '12px 28px', borderRadius: 8, fontSize: 14,
                fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              Ricarica pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
